import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withRequestsMadeViaParent } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
     provideHttpClient(
      withRequestsMadeViaParent(),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
  ],
};
